<template>
	<div v-if="(ptInitData.productInfo.FORM_LP_FLG != 1 || !isLp) &&
		(ptInitData.productInfo.DETAIL_MEMO_P1 ||
			ptInitData.productInfo.DETAIL_MEMO_P2 ||
			ptInitData.productInfo.DETAIL_MEMO_P3 ||
			ptInitData.productInfo.DETAIL_MEMO_P4 ||
			ptInitData.productInfo.DETAIL_MEMO_P5)">

		<!--LP以外の場合-->
		<div class="intruductionContainer">
			<div class="introduction">
				<span class="introductionTitle">
					{{ $t('pt125.labels.itemIntroductionTitle') }}
				</span>
				<span class="introductionEn">
					{{ $t('pt125.labels.itemIntroduction') }}
				</span>
			</div>
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P1"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P1 != '' && ptInitData.productInfo.DETAIL_MEMO_P1 != undefined"
				class="detailMemoP1"></p>
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P2"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P2 != '' && ptInitData.productInfo.DETAIL_MEMO_P2 != undefined"
				class="detailMemoP2"></p>
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P3"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P3 != '' && ptInitData.productInfo.DETAIL_MEMO_P3 != undefined"
				class="detailMemoP3"></p>
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P4"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P4 != '' && ptInitData.productInfo.DETAIL_MEMO_P4 != undefined"
				class="detailMemoP4"></p>
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P5"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P5 != '' && ptInitData.productInfo.DETAIL_MEMO_P5 != undefined"
				class="detailMemoP5"></p>
		</div>
	</div>
	<div v-else>

		<!--LPの場合は位置変更できる様に、階層の深さを合わせる-->
		<div class="intruductionContainerLp0" v-if="(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) &&
			(ptInitData.productInfo.DETAIL_MEMO_P1 ||
				ptInitData.productInfo.DETAIL_MEMO_P2 ||
				ptInitData.productInfo.DETAIL_MEMO_P3 ||
				ptInitData.productInfo.DETAIL_MEMO_P4 ||
				ptInitData.productInfo.DETAIL_MEMO_P5)">
			<div class="introduction">
				<span class="introductionTitle">
					{{ $t('pt125.labels.itemIntroductionTitle') }}
				</span>
				<span class="introductionEn">
					{{ $t('pt125.labels.itemIntroduction') }}
				</span>
			</div>
		</div>
		<div class="intruductionContainerLp1"
			v-if="ptInitData.productInfo.FORM_LP_FLG == 1 && isLp && ptInitData.productInfo.DETAIL_MEMO_P1">
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P1"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P1 != '' && ptInitData.productInfo.DETAIL_MEMO_P1 != undefined"
				class="detailMemoP1"></p>
		</div>
		<div class="intruductionContainerLp2"
			v-if="ptInitData.productInfo.FORM_LP_FLG == 1 && isLp && ptInitData.productInfo.DETAIL_MEMO_P2">
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P2"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P2 != '' && ptInitData.productInfo.DETAIL_MEMO_P2 != undefined"
				class="detailMemoP2"></p>
		</div>
		<div class="intruductionContainerLp3"
			v-if="ptInitData.productInfo.FORM_LP_FLG == 1 && isLp && ptInitData.productInfo.DETAIL_MEMO_P3">
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P3"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P3 != '' && ptInitData.productInfo.DETAIL_MEMO_P3 != undefined"
				class="detailMemoP3"></p>
		</div>
		<div class="intruductionContainerLp4"
			v-if="ptInitData.productInfo.FORM_LP_FLG == 1 && isLp && ptInitData.productInfo.DETAIL_MEMO_P4">
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P4"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P4 != '' && ptInitData.productInfo.DETAIL_MEMO_P4 != undefined"
				class="detailMemoP4"></p>
		</div>
		<div class="intruductionContainerLp5"
			v-if="ptInitData.productInfo.FORM_LP_FLG == 1 && isLp && ptInitData.productInfo.DETAIL_MEMO_P5">
			<p v-html="ptInitData.productInfo.DETAIL_MEMO_P5"
				v-if="ptInitData.productInfo.DETAIL_MEMO_P5 != '' && ptInitData.productInfo.DETAIL_MEMO_P5 != undefined"
				class="detailMemoP5"></p>
		</div>
	</div>
</template>
<script>
	export default {
		components: {
		},
		methods: {
		},
		name: 'intruductionContainer',
		props: {
			ptInitData: {
				type: Object,
				default: null
			}
		}
	}
</script>